module.exports = __webpack_public_path__ + "b21d1c9363afdc64eeb489f8a01fa0e6.jpg";